import { render, staticRenderFns } from "./ArchiveInventoryAction.vue?vue&type=template&id=03cefd4d&scoped=true"
import script from "./ArchiveInventoryAction.vue?vue&type=script&lang=js"
export * from "./ArchiveInventoryAction.vue?vue&type=script&lang=js"
import "./ArchiveInventoryAction.vue?vue&type=style&index=0&id=03cefd4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cefd4d",
  null
  
)

export default component.exports